import { BASE_URLS } from "./src/constants/constants";

const appendScript = (src: string, type: string = "text/javascript") => {
  const script = document.createElement("script");
  script.setAttribute(type === "module" ? "type" : "nomodule", type);
  script.setAttribute("src", `${src}?v=${new Date().getTime()}`);
  document.body.appendChild(script);
};

export const onRouteUpdate = (): void => {
  if (typeof window !== "undefined") {
    const path = window.location.pathname;

      if (path.includes("/faq")) {
        appendScript(`${BASE_URLS.UIC_SBX}/build/ui-component-library.esm.js`, "nomodule");
        appendScript(`${BASE_URLS.UIC_SBX}/build/ui-component-library.esm.js`, "module");
        appendScript(`${BASE_URLS.WBU_SBX}/rozieai.esm.js`, "nomodule");
        appendScript(`${BASE_URLS.WBU_SBX}/rozieai.esm.js`, "module");
      } else {
        appendScript(`${BASE_URLS.WBU_DEV}/rozieai.esm.js`, "nomodule");
        appendScript(`${BASE_URLS.WBU_DEV}/rozieai.esm.js`, "module");
      }
  }
};
